// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/components/panel.scss
// module id = 198
// module chunks = 0